﻿module.exports = function ($) {
    return {
        init: function () {
            var imageGalleryPage = $(".resourceImageGallery").length > 0;
            if (imageGalleryPage) this.bindEvents();
        },
        bindEvents: function () {

            $('#load-more-media').on('click', function () {
                var perPage = $(".resourceImageGallery").attr("data-mediaperpage");
                $(".resourceImageGallery").find('.resourceImageGallery__item:hidden').slice(0, perPage).fadeIn();

                if ($(".resourceImageGallery").find('.resourceImageGallery__item:hidden').length == 0) {
                    $('.resourceImageGallery__loadMoreButton').hide();
                }
            });

            //$(document).ready(function () {
                $('.resourceImageGallery__row').magnificPopup({
                    delegate: 'a',
                    type: 'image',
                    gallery: {
                        enabled: true,
                        arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button
                        tCounter: ''
                    },
                    image: {
                        // options for image content type
                        titleSrc: function (item) {
                            var html = '';
                            var title = item.el.attr('title');
                            var source = item.el.attr('data-source');
                            var copyright = item.el.attr('data-copyright');
                            
                            var caption = $('<div class="resourceImageGallery__caption"></div>');
                            var meta = $('<div class="resourceImageGallery__meta"></div>');
                            var metaSource = $('<span>Source: </span>');
                            var metaCopyright = $('<span>Copyright: </span>');
                            
                            if(title !== ''){
                                $(caption).append(title);
                                html += $(caption)[0].outerHTML;
                            }

                            if(source !== '')
                                $(meta).append($(metaSource).append(source));

                            if(copyright !== '')
                                $(meta).append($(metaCopyright).append(copyright));

                            if (copyright !== '' || source !== '')
                                html += $(meta)[0].outerHTML;

                            return html;
                        }
                    },
                    closeMarkup: '<button title="%title%" type="button" class="mfp-close"></button>',
                    closeBtnInside: true
                });
            //});
        }
    }
}